import { Component } from '@angular/core';

/**
 * Generated class for the SocialWallComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'social-wall',
  templateUrl: 'social-wall.html',
})
export class SocialWallComponent {
  text: string;

  constructor() {
    this.text = 'Hello World';
  }
}



// WEBPACK FOOTER //
// ./src/components/social-wall/social-wall.ts